export default "/institutions/capital-one.svg";